import {
    CACHE_ATTACHMENTS_IMAGES_URLS,
    CHANGE_IMAGE_ZOOM_PERCENTAGE,
    CHANGE_ROTATION,
    CHANGE_SELECTED_DOCUMENT,
    CHANGE_ZOOM_PERCENTAGE,
    DOCUMENT_PREVIEW_DETACH,
    DOCUMENT_PREVIEW_REATTACH,
    DOCUMENT_PREVIEW_STATUS_CHANGED,
    DOCUMENT_PREVIEW_TITLE_CHANGED,
    EDITOR_DETACH,
    EDITOR_REATTACH,
    EDITOR_TITLE_CHANGED,
    DRAFT_COMMENT_LOAD_ERROR,
    DRAFT_COMMENT_LOADED,
    DRAFT_COMMENT_SAVE_STATUS_CHANGED,
    HAS_EDITED_DOCUMENT,
    IFRAME_HAS_CHANGES,
    IFRAME_HAS_VBNXT_SAVE_DISCARD_FLAG,
    TASK_COMMENTS_LOADED,
    TASK_COMMENTS_LOADING,
    TASK_DETAILS_CLOSING,
    TASK_DETAILS_LOADED,
    TASK_DETAILS_LOADED_BY_UID,
    TASK_DETAILS_LOADING,
    TASK_DETAILS_LOADING_ERROR,
    TASK_DETAILS_REDIRECTED,
    TASK_DOCUMENT_DATA_LOADED,
    TASK_DOCUMENT_DATA_LOADING,
    TASK_DOCUMENT_DATA_LOADING_ERROR,
    UPDATE_DOCUMENT_VERSION,
    WORKFLOW_DETAILS_LOADED,
    WORKFLOW_DETAILS_LOADING,
    WORKFLOW_DETAILS_LOADING_ERROR,
    WORKFLOW_HISTORY_LOADED,
} from "../store/actionTypes";
import * as Api from 'utils/api/api';
import {handleError, insufficientRightsError} from 'utils/errorHandle.function';
import _ from "lodash";
import {COMMENT_SAVING_STATUS, TASK_ACTIONS} from "utils/constants";
import {getUsersCurrentContextId} from "components/store/application.reducers.js";
import {handleMyTasksResponseByUID} from "components/mytasks/myTasks.action.js";


export function tasksDetailsLoaded(taskDetails = {}) {
    return {
        type: TASK_DETAILS_LOADED,
        data: taskDetails
    };
}

export function tasksDetailsLoadedByUid(taskDetails = {}) {
    return {
        type: TASK_DETAILS_LOADED_BY_UID,
        data: taskDetails
    };
}

export function taskDetailsLoading(tasksArray = []) {
    return {
        type: TASK_DETAILS_LOADING,
        data: tasksArray
    };
}

export function taskDetailsClosing(tasksArray = []) {
    return {
        type: TASK_DETAILS_CLOSING
    };
}

export function tasksDetailsLoadingFailed(error) {
    return {
        type: TASK_DETAILS_LOADING_ERROR,
        data: error
    };
}

export function tasksDetailsRedirected(redirectedTask = {}) {
    return {
        type: TASK_DETAILS_REDIRECTED,
        data: redirectedTask
    };
}

export function historyTasksDetailsLoadingFailed(error) {
    return {
        type: TASK_DETAILS_LOADING_ERROR,
        data: error
    }
}

export function workflowDetailsLoadingFailed(error) {
    return {
        type: WORKFLOW_DETAILS_LOADING_ERROR,
        data: error
    }
}

export function selectedDocumentChanged(index) {
    return {
        type: CHANGE_SELECTED_DOCUMENT,
        index: index
    }
}

export function removeSelectedDocument() {
    return {
        type: CHANGE_SELECTED_DOCUMENT,
        data: {},
        index: 0
    }
}

export function historyTasksDetailsLoaded(historyTaskDetails = {}) {
    return {
        type: TASK_DETAILS_LOADED,
        data: historyTaskDetails
    };
}

export function historyTasksDetailsLoadedByUid(historyTaskDetails = {}) {
    return {
        type: TASK_DETAILS_LOADED_BY_UID,
        data: historyTaskDetails
    };
}

export function documentDetailsLoaded(documentDetails = {}) {
    return {
        type: TASK_DETAILS_LOADED,
        data: documentDetails
    };
}

export function hasEditedDocument() {
    return {
        type: HAS_EDITED_DOCUMENT,
        data: true

    }
}

export function workflowDetailsLoaded(data) {
    return {
        type: WORKFLOW_DETAILS_LOADED,
        data: data

    }
}

export function workflowDetailsLoading() {
    return {
        type: WORKFLOW_DETAILS_LOADING
    }
}

export function workflowHistoryLoaded(data) {
    return {
        type: WORKFLOW_HISTORY_LOADED,
        data: data

    }
}

export function updateDocumentVersion(version) {
    return {
        type: UPDATE_DOCUMENT_VERSION,
        data: version

    }
}

export function taskDocumentDataLoading() {
    return {
        type: TASK_DOCUMENT_DATA_LOADING
    }
}

export function taskDocumentDataLoaded(data) {
    return {
        type: TASK_DOCUMENT_DATA_LOADED,
        data: data
    }
}

export function taskDocumentDataLoadingFailed(error) {
    return {
        type: TASK_DOCUMENT_DATA_LOADING_ERROR,
        data: error
    }
}

export function draftCommentLoaded(data) {
    return {
        type: DRAFT_COMMENT_LOADED,
        data: data
    }
}

export function draftCommentLoadError(data) {
    return {
        type: DRAFT_COMMENT_LOAD_ERROR,
    }
}

export function draftCommentSavingStatusChange(data) {
    return {
        type: DRAFT_COMMENT_SAVE_STATUS_CHANGED,
        data: data
    }
}

export function taskCommentsLoading() {
    return {
        type: TASK_COMMENTS_LOADING
    }
}

export function taskCommentsLoaded(data) {
    return {
        type: TASK_COMMENTS_LOADED,
        data: data
    }
}

export function changeZoomPercentage(zoom) {
    return {
        type: CHANGE_ZOOM_PERCENTAGE,
        data: zoom
    }
}

export function changeImageZoomPercentage(zoom) {
    return {
        type: CHANGE_IMAGE_ZOOM_PERCENTAGE,
        data: zoom
    }
}

export function changeRotation(rotation) {
    return {
        type: CHANGE_ROTATION,
        data: rotation
    }

}

export function updateTaskDetailsAfterAction(taskId, action) {
    return function (dispatch) {
        dispatch(getTaskDetails(taskId, true, action));
    }
}

export function cacheAttachmentsImagesUrls(attachmentIndex, imageIndex, imageURL) {
    return {
        type: CACHE_ATTACHMENTS_IMAGES_URLS,
        data: {attachmentIndex, imageIndex, imageURL}
    }

}

export function documentPreviewDetach() {
    return {
        type: DOCUMENT_PREVIEW_DETACH
    }
}

export function documentPreviewReattach() {
    return {
        type: DOCUMENT_PREVIEW_REATTACH
    }
}

export function documentPreviewTitleChanged(title) {
    return {
        type: DOCUMENT_PREVIEW_TITLE_CHANGED,
        data: title
    }
}

export function documentPreviewStatusChanged(status) {
    return {
        type: DOCUMENT_PREVIEW_STATUS_CHANGED,
        data: status
    }
}

export function editorDetach() {
    return {
        type: EDITOR_DETACH
    }
}

export function editorReattach() {
    return {
        type: EDITOR_REATTACH
    }
}

export function editorTitleChanged(title) {
    return {
        type: EDITOR_TITLE_CHANGED,
        data: title
    }
}

export function integrationIframeHasUnsavedChanges(hasChanges) {
    return {
        type: IFRAME_HAS_CHANGES,
        data: hasChanges
    }
}

export function iframeHasVBNXTFlag(hasFlag) {
    return {
        type: IFRAME_HAS_VBNXT_SAVE_DISCARD_FLAG,
        data: hasFlag
    }
}

export function getTaskDetails(taskId, isSilent = false, action = null) {
    return function (dispatch) {

        if (!isSilent)
            dispatch(taskDetailsLoading());

        return Api.getTaskDetails(taskId).then(
            response => {
                dispatch(handleTaskDetailsResponse(response, taskId, action));
            }, error => {
                dispatch(tasksDetailsLoadingFailed(error));
                handleError(error.errorCode === 304 ? insufficientRightsError : error);
                //throw error;
            }
        )
    }
}

// the details slice holds one task, so a response is stale once another uid has been requested
let latestRequestedUid = null;

function isLatestRequestedUid(uid) {
    return latestRequestedUid === uid;
}

export function getTaskDetailsByUID(uid, isSilent = false, action = null) {
    return function (dispatch) {
        latestRequestedUid = uid;

        if (!isSilent)
            dispatch(taskDetailsLoading());

        return Api.getTaskDetailsByUID(uid).then(
            response => {
                if (!isLatestRequestedUid(uid)) return;

                dispatch(handleTaskDetailsResponseByUID(response, action));
                dispatch(handleMyTasksResponseByUID(response));
            }, error => {
                if (!isLatestRequestedUid(uid)) return;

                if (error.httpStatus !== 404) {
                    dispatch(tasksDetailsLoadingFailed(error));
                    handleError(error.errorCode === 304 ? insufficientRightsError : error);
                } else {
                    dispatch(redirectTaskByUID(uid));
                }
            }
        )
    }
}

// only the by-uid views pass a uid, and /tasks/<uid> is routable with fe-details-by-uid off, so this
// follows the open view rather than the flag (AC-12800)
export function refreshTaskDetails(taskKey, uid, isSilent = false, action = null) {
    return function (dispatch) {
        if (uid)
            return dispatch(getTaskDetailsByUID(uid, isSilent, action));

        return dispatch(getTaskDetails(taskKey, isSilent, action));
    }
}

export function redirectTaskByUID(uid) {
    return function (dispatch) {
        return Api.getDeletedTaskByUID(uid).then(
            response => {
                dispatch(tasksDetailsRedirected(response));
            }, error => {
                dispatch(tasksDetailsLoadingFailed(error));
                handleError(error.errorCode === 304 ? insufficientRightsError : error);
            }
        )
    }
}

function handleTaskDetailsResponse(response, taskId, action) {
    return function (dispatch) {
        let newAttachments = response.attachmentCollection ? _.cloneDeep(response.attachmentCollection) : [];

        if (newAttachments?.attachments) {
            newAttachments = {
                attachments: newAttachments.attachments.map(attachment => {
                    delete attachment.pageCount;
                    delete attachment.urlsOriginal;
                    delete attachment.urlsOriginalJson;
                    return attachment
                })
            }
        }

        let value = {
            taskDetails: response,
            attachments: newAttachments
        };
        dispatch(tasksDetailsLoaded(value));

        if (action === TASK_ACTIONS.ADD_ATTACHMENT) {
            let selectedDocument = response.attachmentCollection.attachments[response.attachmentCollection.attachments.length - 1];
            dispatch(selectedDocumentChanged(response.attachmentCollection.attachments.length - 1));
        }
    }
}

function handleTaskDetailsResponseByUID(response, action) {
    return function (dispatch) {

        let newAttachments = response.details.attachmentCollection ? _.cloneDeep(response.details.attachmentCollection) : [];

        if (newAttachments?.attachments) {
            newAttachments = {
                attachments: newAttachments.attachments.map(attachment => {
                    delete attachment.pageCount;
                    delete attachment.urlsOriginal;
                    delete attachment.urlsOriginalJson;
                    return attachment
                })
            }
        }

        let value = {
            task: response,
            taskDetails: response.details,
            attachments: newAttachments
        };
        dispatch(tasksDetailsLoadedByUid(value));

        // the collection is optional above, so an add-attachment response without one must not select
        const attachments = response.details.attachmentCollection?.attachments;
        if (action === TASK_ACTIONS.ADD_ATTACHMENT && attachments?.length) {
            dispatch(selectedDocumentChanged(attachments.length - 1));
        }
    }
}

export function getHistoryTaskDetailsWithPermissions(processUid, isSilent = false) {
    return function (dispatch) {

        if (!isSilent)
            dispatch(taskDetailsLoading());
        let value = {};

        //get the attachments, these are separate for a history task
        const getAttachements = Api.getAttachmentsForProcess(processUid).then(
            response => {
                value.taskDetails = Object.assign({}, value.taskDetails, response);
                value.attachments = response.attachmentCollection ? response.attachmentCollection : null;

                // if (response.attachmentCollection && response.attachmentCollection.attachments)
                //     dispatch(_reloadFromCIR(taskId, response.attachmentCollection.attachments, getHistoryTaskDetails));
            },
            error => {
                dispatch(historyTasksDetailsLoadingFailed(error));
                handleError(error);
                //throw error;
            }
        );

        //Because we need to know if the editor is visible or not we need to have this call here
        //response.externalEditorAvailable is the value we need
        let hasProcess = false;
        const getDocumentInfo = Api.getProcessByUID(processUid).then(response => {
                hasProcess = true;
                value.taskDetails = Object.assign({}, value.taskDetails, response);

                return Api.getProcessPermissions(value.taskDetails.uid).then((response) => {
                    value.permissions = response.result;
                }, error => {
                    handleError(error);
                })
            },
            error => {
                // the loading dispatch above has to be closed out, or the status never leaves LOADING (AC-12773)
                dispatch(historyTasksDetailsLoadingFailed(error));
                handleError(error);
                // throw error;
            }
        );

        return Promise.all([getAttachements, getDocumentInfo]).then(
            () => {
                // the attachments response populates taskDetails too, so only this flag says whether there is a task (AC-12773)
                if (!hasProcess)
                    return;

                return dispatch(historyTasksDetailsLoaded(value));
            }
        );
    }
}


export function getProcessByUID(uid, isSilent = false) {
    return function (dispatch) {

        if (!isSilent)
            dispatch(taskDetailsLoading());
        let value = {};

        //Beacuse we need to know if the editor is visible or not we need to have this call here
        //response.externalEditorAvailable is the value we need
        return Api.getProcessByUID(uid).then(response => {
                value.task = Object.assign({}, value.task, response);
                value.taskDetails = Object.assign({}, value.taskDetails, response);
                return Api.getAttachmentsForProcess(uid).then(
                    rsp => {
                        value.attachments = rsp.attachmentCollection ? rsp.attachmentCollection : null;

                        dispatch(historyTasksDetailsLoadedByUid(value));
                        // if (response.attachmentCollection && response.attachmentCollection.attachments)
                        //     dispatch(_reloadFromCIR(taskId, response.attachmentCollection.attachments, getHistoryTaskDetails));
                    },
                    error => {
                        dispatch(historyTasksDetailsLoadingFailed(error));
                        handleError(error);
                        //throw error;
                    }
                );
            },
            error => {
                // the loading dispatch above has to be closed out, or the status never leaves LOADING (AC-12773)
                dispatch(historyTasksDetailsLoadingFailed(error));
                handleError(error);
                // throw error;
            }
        );
    }
}

export function getProcessByUIDWithPermissions(uid, isSilent = false) {
    return function (dispatch) {
        latestRequestedUid = uid;

        if (!isSilent)
            dispatch(taskDetailsLoading());
        let value = {};

        const getPermissions = Api.getProcessPermissions(uid).then((response) => {
            value.permissions = response.result;
        }, error => {
            if (!isLatestRequestedUid(uid)) return;

            handleError(error);
        })

        //Beacuse we need to know if the editor is visible or not we need to have this call here
        //response.externalEditorAvailable is the value we need
        const getProcess = Api.getProcessByUID(uid).then(response => {
                value.task = Object.assign({}, value.task, response);
                value.taskDetails = Object.assign({}, value.taskDetails, response);
                return Api.getAttachmentsForProcess(uid).then(
                    rsp => {
                        value.attachments = rsp.attachmentCollection ? rsp.attachmentCollection : null;
                    },
                    error => {
                        if (!isLatestRequestedUid(uid)) return;

                        dispatch(historyTasksDetailsLoadingFailed(error));
                        handleError(error);
                        //throw error;
                    }
                );
            },
            error => {
                if (!isLatestRequestedUid(uid)) return;

                // the loading dispatch above has to be closed out, or the status never leaves LOADING (AC-12773)
                dispatch(historyTasksDetailsLoadingFailed(error));
                handleError(error);
                // throw error;
            }
        );

        return Promise.all([getProcess, getPermissions]).then(
            () => {
                if (!isLatestRequestedUid(uid)) return;

                // a rejection is already reported by the handler above; this only backstops the invariant
                // that "loaded" never fires without a task, which is what blanked the details (AC-12773)
                if (!value.taskDetails)
                    return;

                return dispatch(historyTasksDetailsLoadedByUid(value));
                // if (response.attachmentCollection && response.attachmentCollection.attachments)
                //     dispatch(_reloadFromCIR(taskId, response.attachmentCollection.attachments, getHistoryTaskDetails));
            }
        );
    }
}

export function getDocumentOverviewDetailsWithPermissions(taskId, documentUID, isExternalEditorAvailable, companyId) {
    return function (dispatch, getState) {
        dispatch(taskDetailsLoading());
        let value = {};
        const getAttachments = Api.getDocumentOverviewAttachments(taskId).then(response => {
                let state = getState();
                const foundTask = state.documentOverview.tasks.rows.find(x => x.key === taskId);
                const foundUid = foundTask?.documentUid || documentUID;
                const foundVersion = foundTask?.version;
                value.attachments = response.attachmentCollection;
                value.taskDetails = {...response, uid: foundUid, documentVersion: foundVersion};
                value.taskDetails.externalEditorAvailable = isExternalEditorAvailable;
                value.taskDetails.attachmentCollection = response.attachmentCollection;
            },
            error => {
                //back-end doesn't send a json error it's plain text so the handling will fail, there should be a back-end task to fix this
                // dispatch(handleError(newError));
            }
        );

        const getPermissions = Api.getDocumentPermissions(documentUID).then((response) => {
            value.permissions = response.result;
        }, error => {
            handleError(error);
        })

        return Promise.all([getAttachments, getPermissions]).then(
            () => {
                return dispatch(documentDetailsLoaded(value));
                // if (response.attachmentCollection && response.attachmentCollection.attachments)
                //     dispatch(_reloadFromCIR(taskId, response.attachmentCollection.attachments, getHistoryTaskDetails));
            }
        );
    }
}

export function getWorkflowDetails(taskId, isDocument) {
    return function (dispatch, getState) {
        dispatch(workflowDetailsLoading());
        if (isDocument) {
            let state = getState();
            const companyId = getUsersCurrentContextId(state);
            return Api.getWorkflowGraphDataForDocumentOverview(taskId, companyId).then((response) => {
                const {events, ...workflowData} = response
                dispatch(workflowDetailsLoaded(workflowData));
                dispatch(workflowHistoryLoaded({events}));
            }, error => {
                dispatch(workflowDetailsLoadingFailed(error));
                handleError(error);
            })
        } else {
            return Api.getWorkflowGraphData(taskId).then((response) => {
                const {events, ...workflowData} = response
                dispatch(workflowDetailsLoaded(workflowData));
                dispatch(workflowHistoryLoaded({events}));
                // eventBus.dispatch('@@grid/refreshGridLayout');
            }, error => {
                dispatch(workflowDetailsLoadingFailed(error));
                handleError(error);
            })
        }
    }
}

export function getTaskDocumentData(taskId, isDocument) {
    return function (dispatch, getState) {
        dispatch(taskDocumentDataLoading());
        if (isDocument) {
            let state = getState();
            const companyId = getUsersCurrentContextId(state);
            return Api.getDocumentOverviewDetails(taskId, companyId).then((response) => {
                dispatch(taskDocumentDataLoaded(response));
            }, error => {
                dispatch(taskDocumentDataLoadingFailed(error));
                handleError(error);
            });
        } else {
            return Api.getTaskDocumentDetails(taskId).then((response) => {
                dispatch(taskDocumentDataLoaded(response));
            }, error => {
                dispatch(taskDocumentDataLoadingFailed(error));
                handleError(error);
            })
        }
    }
}

export function getDraftComment(documentUid) {
    return function (dispatch) {
        Api.getDraftComment(documentUid).then((response) => {
            dispatch(draftCommentLoaded(response));
        }, error => {
            dispatch(draftCommentLoadError());
            //handleError(error);
        })
    }
}

export function handleAddTasksDraftComment(documentUID, comment, successCallback, errorCallback) {
    return function (dispatch) {
        Api.insertDraftComment(documentUID, comment).then(() => {
            successCallback();
        }, error => {
            handleError(error);
            errorCallback();
        })
    }
}


export function getTaskCommentsByUid(uid, skipLoading = false) {
    return function (dispatch) {
        if (!skipLoading) {
            dispatch(taskCommentsLoading());
        }
        Api.getTasksCommentsByUid(uid).then((response) => {
            dispatch(taskCommentsLoaded(response));
        }, error => {
            // the panel shows a skeleton while loading, so it has to be told the load is over
            dispatch(taskCommentsLoaded([]));
            handleError(error);
        })
    }
}

export function getProcessAndHistoryComments(uid, processId, skipLoading = false) {
    return function (dispatch) {
        if (!skipLoading) {
            dispatch(taskCommentsLoading());
        }
        Api.getProcessesComments(processId).then((response) => {
            dispatch(taskCommentsLoaded(response));
        }, error => {
            handleError(error);
        })
    }
}

export function getDocumentsComments(uid, documentId, skipLoading = false) {
    return function (dispatch) {
        if (!skipLoading) {
            dispatch(taskCommentsLoading());
        }
        Api.getDocumentsComments(documentId).then((response) => {
            dispatch(taskCommentsLoaded(response));
        }, error => {
            handleError(error);
        })
    }
}

export function handleAddTasksDraftComments(taskKey, comment, documentUid, uid) {
    return function (dispatch) {
        Api.insertTasksComment(taskKey, comment).then(() => {
            dispatch(getTaskCommentsByUid(uid, true));
            dispatch(getWorkflowDetails(taskKey, false));
            dispatch(getDraftComment(documentUid));
            dispatch(draftCommentSavingStatusChange(COMMENT_SAVING_STATUS.DONE));
        }, error => {
            handleError(error);
            dispatch(draftCommentSavingStatusChange(COMMENT_SAVING_STATUS.ERROR));
        })
    }
}

export function handleAddDocumentsDraftCommentsByUID(documentKey, comment, documentUid, uid) {
    return function (dispatch) {
        Api.insertDocumentsCommentByUID(documentUid, comment).then(() => {
            dispatch(getDocumentsComments(uid, documentKey, true));
            dispatch(getWorkflowDetails(documentKey, true));
            dispatch(getDraftComment(documentUid));
            dispatch(draftCommentSavingStatusChange(COMMENT_SAVING_STATUS.DONE));
        }, error => {
            handleError(error);
            dispatch(draftCommentSavingStatusChange(COMMENT_SAVING_STATUS.ERROR));
        })
    }
}

export function handleAddProcessAndHistoryDraftCommentsByUID(processKey, comment, documentUid, uid) {
    return function (dispatch) {
        Api.insertProcessesCommentByUID(uid, comment).then(() => {
            dispatch(getProcessAndHistoryComments(uid, processKey, true));
            dispatch(getWorkflowDetails(processKey, false));
            dispatch(getDraftComment(documentUid));
            dispatch(draftCommentSavingStatusChange(COMMENT_SAVING_STATUS.DONE));
        }, error => {
            handleError(error);
            dispatch(draftCommentSavingStatusChange(COMMENT_SAVING_STATUS.ERROR));
        })
    }
}
